import { Component, OnInit,  Input,  ViewChild} from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import {MatSidenav} from '@angular/material/sidenav';
import { PageConfig } from 'src/app/models/display/pageConfig';
import { AutorizationService } from 'src/app/api/autorization.service';
import { PageConfigService } from 'src/app/page-config.service';

@Component({
  selector: 'app-basic-service',
  templateUrl: './basic-service.component.html',
  styleUrls: ['./basic-service.component.scss']
})
export class BasicServiceComponent implements OnInit {
  @Input() dataKey;
  private seletedService : string = null;
  @ViewChild('sidenav') sidenav:MatSidenav;
  public isLoad = false;

  pageConfig: PageConfig = null;
  constructor(private route: ActivatedRoute, private pageConfigService: PageConfigService, private autorizationService: AutorizationService) {

  }
  
  close() {
    this.sidenav.close();
  }

  fragment : String;

  ngOnInit() {
    
    this.route
    .data
    .subscribe(v => v);

    this.pageConfig = null;
    this.autorizationService.login(null).subscribe(
      reponse => {
        // conslog("login");

        this.pageConfigService.getConfig(this.pageConfigService.defaultConfig).subscribe(
          reponse => {
            //            this.pageConfig = <PageContent>reponse;
            // conslog("this.pageConfig");
            this.pageConfig = < PageConfig > reponse;
            // conslog(this.pageConfig.servicesList);

            this.isLoad = true;
          },
          error => {
            this.pageConfigService.getConfig(this.pageConfigService.defaultConfig).subscribe(
              reponse => {
                this.pageConfig = < PageConfig > reponse;
              }
            )
          }
        )
      }
    )



    this.route.fragment.subscribe(fragment => { 
        this.fragment = fragment;  
        //  console.log("log :",this.fragment); 
        this.scrollHtag()});
    
  }


  scrollHtag() {
    if(this.fragment) {
      document.querySelector('#comment-ca-marche').scrollIntoView(false);
      // window.location.href = "#comment-ca-marche"
    } 
}

}
